import { Engine } from 'engine/Engine';
import { Facet } from 'engine/facets/Facet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { AxeIcon } from 'game/components/modules/icons/AxeIcon';
import { LaserIcon } from 'game/components/modules/icons/LaserIcon';
import { WaterIcon } from 'game/components/modules/icons/WaterIcon';
import { WateringCanIcon } from 'game/components/modules/icons/WateringCanIcon';
import { createStyle } from 'game/lib/createStyles';
import { NoSprite } from 'game/sprites/NoSprite';
import { TooltipSprite } from 'game/sprites/TooltipSprite';
import { BotToolChoice, InventorySelection, ProcessError, ProcessStatus } from 'game/state/BotState';
import { Fragment, createElement } from 'react';

const props = {
  tooltip: {
    className: createStyle('tooltip', {
      transform: 'translate(0, 7px)',
    }),
  },
  icon: {
    className: createStyle('icon', {
      transform: 'scale(0.6)',
      transformOrigin: 'center',
    }),
  },
  noSymbol: {
    className: createStyle('noSymbol', { mixBlendMode: 'color-dodge' }),
  },
  emoji: {
    y: 7,
    className: createStyle('emoji', {
      textAnchor: 'middle',
      dominantBaseline: 'middle',
      fontSize: 90,
    }),
  },
};

interface BotTooltipProps {
  result: ProcessStatus | null,
}

export class BotTooltipBehavior extends Facet<BotTooltipProps> {

  tooltip: StaticSpriteFacet = create(StaticSpriteFacet, { frame: null, offset: [0, -260] });

  start(engine: Engine) {
    this.entity.addFacet(this.tooltip, engine);
  }

  getIcon(error: ProcessError): JSX.Element | null {
    switch (error.type) {
      case 'missing': {
        switch (error.item) {
          case BotToolChoice.Axe: return createElement(AxeIcon);
          case BotToolChoice.WateringCan: return createElement(WateringCanIcon);
          case BotToolChoice.Laser: return createElement(LaserIcon);
          case InventorySelection.RedHerring: return null;
          case InventorySelection.Water: return createElement(WaterIcon);
        }
      }
      // eslint-disable-next-line no-fallthrough
      case 'unclear': {
        return createElement('text', props.emoji, '🤷');
      }
    }
  }

  getFrame(): JSX.Element | null {
    const { result } = this.props;
    if (!result || result.status !== 'error') return null;

    return createElement(Fragment, {}, ...[
      createElement('g', props.tooltip, TooltipSprite()),
      createElement('g', props.icon, this.getIcon(result.error)),
      result.error.type === 'missing'
        ? createElement('g', props.noSymbol, NoSprite)
        : null,
    ]);
  }

  update(): void {
    this.tooltip.props.frame = this.getFrame();
  }
}
